/**
 * Mobile Navigation
 */

// Toggle mobile nav
$('[data-toggle="mobile-nav"]').on('click', event => {
  event.preventDefault();
  $(event.currentTarget).toggleClass('is-active');
  $('.nav-mobile').toggleClass('is-visible');
  $('.nav-mobile').scrollTop(0);
  $('body').toggleClass('nav-mobile-is-visible');
  $('html').toggleClass('nav-mobile-is-visible');
});

// Toggle nested menu items
$('.nav-mobile .caret').on('click', event => {
  event.preventDefault();
  if (
    !$(event.currentTarget)
      .siblings('.sub-menu')
      .hasClass('is-visible')
  ) {
    $(event.currentTarget)
      .siblings('.sub-menu')
      .addClass('is-visible');
    $(event.currentTarget).removeClass('caret-down');
    $(event.currentTarget).addClass('caret-up');
  } else {
    $(event.currentTarget)
      .siblings('.sub-menu')
      .removeClass('is-visible');
    $(event.currentTarget).removeClass('caret-up');
    $(event.currentTarget).addClass('caret-down');
  }
});



// WEBPACK FOOTER //
// ./assets/js/components/nav-mobile.js